import { render } from "./LeaderboardPage.vue?vue&type=template&id=72cb117e"
import script from "./LeaderboardPage.vue?vue&type=script&lang=js"
export * from "./LeaderboardPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LeaderboardPage.vue?vue&type=style&index=0&id=72cb117e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__